import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import FA from 'react-fontawesome';

/**
 * ユニットローディングコンポーネント
 */
const UnitLoading = () => {
  const loadingState = useSelector((state) => state.loading);
  // ローディングがセットされていない場合
  if (!loadingState.unitLoading) {
    return '';
  // ローディングがセットされていれば表示する
  } else {
    return (
      <LoadWrap>
        <FA name="refresh" className="loading"/>
      </LoadWrap>
    );
  }
};


const LoadWrap = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999;
    width: 100%;
    height: 100%;
    padding-top: 10px;
    padding-left: 10px;
    min-height: calc(100vh - 90px);
    background-color: #F5F7F7;

    .fa.fa-refresh {
      font-size: 2rem;

    }
`;

export default UnitLoading;

